// extracted by mini-css-extract-plugin
export default {"wrap":"DigitalProfile_wrap__k3M2O","top":"DigitalProfile_top__3x4bI","bottom":"DigitalProfile_bottom__SVvdt"};